import type { PlannedActivity } from '../models/plannedActivity';
import type { ReviewerDetails } from '../models/reviewerDetails';
import type { ConfirmReviewerDetailsParameters } from '../models/confirmReviewerDetailsParameters';
import type { RevieweeCommentDto } from '../models/revieweeCommentDto';
import type { ReviewPcsPdpCommandDto } from '../models/reviewPcsPdpCommandDto';
import { requests } from '../../../app/api/httpClient';

export const PcsPdp = {
    getRevieweeRequestsAsync: () => requests.get(`PcsPdp`),
    updatePlannedActivityAsync: (data: PlannedActivity) => requests.put(`PcsPdp`, data),
    submitReviewerDetailsAsync: (data: ReviewerDetails) => requests.post(`PcsPdp/Reviewer`, data),
    saveRevieweeCommentAsync: (data: RevieweeCommentDto) => requests.put(`PcsPdp/Comment`, data),
    confirmReviewerDetailsAsync: (data: ConfirmReviewerDetailsParameters) => requests.put(`PcsPdp/Reviewer`, data),
    getRevieweeDetailsAsync: (enrolmentYearId: string) => requests.get(`PcsPdp/Reviewee?enrolmentYearId=${enrolmentYearId}`),
    cancelReviewRequestAsync: (enrolmentYearId: string) => requests.put(`PcsPdp/Cancel`, { enrolmentYearId: enrolmentYearId }),
    searchReviewerByImcNumberAsync: (imcNumber: string) => requests.get(`PcsPdp/Reviewer?IMCNumber=${imcNumber}`),
    searchReviewerByPersonIdAsync: (personId: string) => requests.get(`PcsPdp/Reviewer?PersonId=${personId}`),
    getActivitiesAcrossDomainsAsync: () => requests.get(`PcsPdp/DomainSummary`),
    submitReviewAsync: (data: ReviewPcsPdpCommandDto) => requests.put(`PcsPdp/Review`, data),
    declineAsync: (enrolmentYearId: string) => requests.put(`PcsPdp/Decline`, { enrolmentYearId: enrolmentYearId })
};
